// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2LhA1","imageUploader":"EGiftCard_imageUploader__QVL-X"};